import { useTranslation } from 'react-i18next';

import { FeatureCard } from './FeatureCard';
import { ProductPage } from './ProductPage';
import { UpsellStrategy } from './UpsellStrategy';

export function ShopTheLook() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Personalization.components.ShopTheLook',
  });

  return (
    <div className="border-t border-gray-200 bg-gray-50 p-6">
      <div className="space-y-6">
        <div>
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
            <ProductPage />
            <UpsellStrategy />
          </div>

          <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-2">
            <FeatureCard
              title={t('features.feature1.title')}
              description={t('features.feature1.description')}
            />
            <FeatureCard
              title={t('features.feature2.title')}
              description={t('features.feature2.description')}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
